import { RichText } from "../../model/viewModel/richText";
import {
  EditorState,
  SerializedEditorState,
  $createParagraphNode,
  $createTextNode,
  RootNode,
} from "lexical";

const IS_BOLD = 1;
const IS_ITALIC = 1 << 1;
const IS_STRIKETHROUGH = 1 << 2;
const IS_UNDERLINE = 1 << 3;

export const toLexical = (rootNode: RootNode, richTexts: RichText[]): void => {
  rootNode.clear();
  let paragraphNode = $createParagraphNode();
  richTexts?.forEach((richText) => {
    if (richText?.text) {
      const textNode = $createTextNode(richText.text);
      let style = "";
      if (richText.color) {
        style += `color: ${richText.color};`;
      }
      if (richText.fontSize) {
        style += `font-size: ${richText.fontSize};`;
      }
      textNode.setStyle(style);

      let format = 0;
      if (richText.bold) format |= IS_BOLD;
      if (richText.italic) format |= IS_ITALIC;
      if (richText.underline) format |= IS_UNDERLINE;
      if (richText.strikethrough) format |= IS_STRIKETHROUGH;
      textNode.setFormat(format);

      paragraphNode.append(textNode);
    }
    if (richText?.appendLinebreak) {
      rootNode.append(paragraphNode);
      paragraphNode = $createParagraphNode();
    }
  });
  rootNode.append(paragraphNode);
};

export const toRichTexts = (e: EditorState): RichText[] => {
  const richTexts: RichText[] = [];
  const serializedEditorState: SerializedEditorState = e.toJSON();
  findRichTexts(serializedEditorState.root, richTexts);
  return richTexts;
};

const findRichTexts = (editorNode: any, richTexts: RichText[]): void => {
  if (editorNode.text) {
    const richText = new RichText(editorNode.text);
    if (editorNode.style) {
      richText.color = getStyleValue(editorNode.style, "color");
      richText.fontSize = getStyleValue(editorNode.style, "font-size");
    }

    richText.bold = editorNode.format & IS_BOLD ? true : undefined;
    richText.italic = editorNode.format & IS_ITALIC ? true : undefined;
    richText.underline = editorNode.format & IS_UNDERLINE ? true : undefined;
    richText.strikethrough = editorNode.format & IS_STRIKETHROUGH ? true : undefined;

    richTexts.push(richText);
  }
  if (editorNode.children) {
    if (editorNode.type === "paragraph" && richTexts.length) {
      const richText = new RichText("");
      richText.appendLinebreak = true;
      richTexts.push(richText);
    }
    editorNode.children.forEach((child: any) => findRichTexts(child, richTexts));
  }
};

const getStyleValue = (style: string, name: string): string | undefined => {
  const pattern = new RegExp(`;\\s*${name}\\s*:\\s*([^;]+);`);
  return (";" + style).match(pattern)?.[1];
};
